<div class="profile-dropdown-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading profile...</p>
  </div>

  <!-- Profile Content -->
  <div *ngIf="!isLoading">
    <div class="profile-info">
      <div class="avatar">
        <img [src]="getProfileImage()" [alt]="getDisplayName() + ' Avatar'" />
      </div>
      <div class="user-details">
        <div class="user-name">{{ getDisplayName() }}</div>
        <div class="user-role">{{ getDisplayRole() | titlecase }}</div>
      </div>
      <div class="edit-icon" (click)="navigateToSettings()">
        <img src="assets/images/user-edit.svg" alt="Edit Icon" />
      </div>
    </div>
    <div class="info-section">
      <div class="info-item">
        <div class="info-label">Name</div>
        <div class="info-value">{{ getDisplayName() }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">Phone</div>
        <div class="info-value">{{ getDisplayPhone() }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">Email</div>
        <div class="info-value">{{ getDisplayEmail() }}</div>
      </div>
      <div class="info-item" *ngIf="userProfile?.emp_id">
        <div class="info-label">Employee ID</div>
        <div class="info-value">{{ userProfile?.emp_id }}</div>
      </div>
      <div class="info-item" *ngIf="getCompanyName()">
        <div class="info-label">Company</div>
        <div class="info-value">{{ getCompanyName() }}</div>
      </div>
    </div>
    <div class="logout-section" (click)="logout()">
      <div class="logout-icon">
        <img src="/assets/images/logout.svg" alt="Logout Icon" />
      </div>
      <div class="logout-text">Logout</div>
    </div>
  </div>
</div>
